
/* eslint-disable */
/* Note: this code is generated by generateSizingEnums.js, do not modify it */
import React from 'react'
import PropTypes from 'prop-types'

const featureTypes = ["ACCESSORIES","AESTHETIC","BREATHABLE","CABLE MANAGEMENT","CHAMOIS","CLOSURE","COMFORT","COMPACT","COMPRESSION","CONNECTIVITY","CONSTRUCTION DETAIL","DESIGN LENGTH","DURABLE","EAR COVER","FIT","GRIPPER","INSULATION","LENS","LENS WIPE","LIGHTWEIGHT","LOW PROFILE","MATERIAL QUALITY","MOUNTS","NOISE","ODOR RESISTANT","PERFORMANCE","POCKET","PONY TAIL COMPATIBLE","PROTECTION","QUICK DRY","RANGE","RECYCLED","SAFETY","SHOE INSOLE","SHOE SOLE","SHOE UPPER","STRETCH","SUN PROTECTION","SUPPORT","SUSTAINABLE","TOUCH SCREEN COMPATIBLE","VENTILATION","VISIBILITY","WARM WEATHER","WATER RESISTANT","WATERPROOF","WICKING","WINDPROOF"]

class FeatureTranslate extends React.Component {
	render() {
		const translations = {
			"ACCESSORIES": this.context.translate("Accessories"),
			"AESTHETIC": this.context.translate("Aesthetic"),
			"BREATHABLE": this.context.translate("Breathable"),
			"CABLE-MANAGEMENT": this.context.translate("Cable Management"),
			"CHAMOIS": this.context.translate("Chamois"),
			"CLOSURE": this.context.translate("Closure"),
			"COMFORT": this.context.translate("Comfort"),
			"COMPACT": this.context.translate("Compact"),
			"COMPRESSION": this.context.translate("Compression"),
			"CONNECTIVITY": this.context.translate("Connectivity"),
			"CONSTRUCTION-DETAIL": this.context.translate("Construction Detail"),
			"DESIGN-LENGTH": this.context.translate("Design Length"),
			"DURABLE": this.context.translate("Durable"),
			"EAR-COVER": this.context.translate("Ear Cover"),
			"FIT": this.context.translate("Fit"),
			"GRIPPER": this.context.translate("Gripper"),
			"INSULATION": this.context.translate("Insulation"),
			"LENS": this.context.translate("Lens"),
			"LENS-WIPE": this.context.translate("Lens Wipe"),
			"LIGHTWEIGHT": this.context.translate("Lightweight"),
			"LOW-PROFILE": this.context.translate("Low Profile"),
			"MATERIAL-QUALITY": this.context.translate("Material Quality"),
			"MOUNTS": this.context.translate("Mounts"),
			"NOISE": this.context.translate("Noise"),
			"ODOR-RESISTANT": this.context.translate("Odor Resistant"),
			"PERFORMANCE": this.context.translate("Performance"),
			"POCKET": this.context.translate("Pocket"),
			"PONY-TAIL-COMPATIBLE": this.context.translate("Pony Tail Compatible"),
			"PROTECTION": this.context.translate("Protection"),
			"QUICK-DRY": this.context.translate("Quick Dry"),
			"RANGE": this.context.translate("Range"),
			"RECYCLED": this.context.translate("Recycled"),
			"SAFETY": this.context.translate("Safety"),
			"SHOE-INSOLE": this.context.translate("Shoe Insole"),
			"SHOE-SOLE": this.context.translate("Shoe Sole"),
			"SHOE-UPPER": this.context.translate("Shoe Upper"),
			"STRETCH": this.context.translate("Stretch"),
			"SUN-PROTECTION": this.context.translate("Sun Protection"),
			"SUPPORT": this.context.translate("Support"),
			"SUSTAINABLE": this.context.translate("Sustainable"),
			"TOUCH-SCREEN-COMPATIBLE": this.context.translate("Touch Screen Compatible"),
			"VENTILATION": this.context.translate("Ventilation"),
			"VISIBILITY": this.context.translate("Visibility"),
			"WARM-WEATHER": this.context.translate("Warm Weather"),
			"WATER-RESISTANT": this.context.translate("Water Resistant"),
			"WATERPROOF": this.context.translate("Waterproof"),
			"WICKING": this.context.translate("Wicking"),
			"WINDPROOF": this.context.translate("Windproof")
		}
		const { type } = this.props
		return <span>{translations[type]}</span>
	}
}

FeatureTranslate.propTypes = {
	type: PropTypes.string.isRequired
}

FeatureTranslate.contextTypes = {
	translate: PropTypes.func
}

export default FeatureTranslate

export { featureTypes }



// WEBPACK FOOTER //
// ./src/components/FeatureTranslate.jsx